<template>
  <section id="section__review" class="px-3">
    <v-row no-gutters class="landing-container px-3">
      <v-col v-for="(review, i) in reviews" :key="i" cols="12" class="review-box">
        <p class="color--white font--p-6 mb-2">"{{ review.text }}"</p>

        <div class="d-flex align-center">
          <v-avatar v-if="false" size="50" color="white" class="mr-3"> </v-avatar>
          <p class="font--m-6 color--white mb-0">- {{ review.store }} {{ review.name }} 사장님</p>
        </div>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  data() {
    return {
      reviews: [
        {
          text: '타사의 선정산 서비스를 이용해 봤는데 번개입금 서비스는 타사의 절반도 안되는 비용으로 이용이 가능해서 주위에 추천하고 있어요',
          name: '김*영',
          store: 'xx 돼지국밥',
        },
        {
          text: '장사가 잘되는 날엔 기분은 좋지만 다음 날 재료비 고민이 많았는데 번개입금 서비스로 고민이 해결 됐어요',
          name: '박*영',
          store: 'xx 해장국',
        },
        {
          text: '배달 매출 늦게 들어오는 고민이 싹 해결되었어요',
          name: '최*호',
          store: 'xx 치킨',
        },
        {
          text: '카드 매출 뿐만 아니라 배달 매출까지 정확하게 정산 되니 너무 편해요',
          name: '이*수',
          store: 'xxx 식당',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
#section__review {
  display: flex !important;
  flex-direction: column;
  overflow: hidden;
  background-color: #4a4a4a;

  .apply-btn {
    background-color: #d30000;
    color: white;
    width: 80%;
    height: 50px;
    font-size: 18px;
  }

  .review-box:not(:last-child) {
    margin-bottom: 3rem;
  }
}
</style>
